import type { ReactElement } from "react";
import type { CrewMember } from "../../hooks/useSubmissionMutations";

interface CrewListProps {
  crew: CrewMember[];
  onRemove: (index: number) => void;
}

/**
 * Crew List Component
 * Displays crew members with their roles
 */
export function CrewList({ crew, onRemove }: Readonly<CrewListProps>): ReactElement {
  return (
    <div className="space-y-2 mt-4">
      {crew.map((member, index) => (
        <div
          key={`${member.name}-${member.job}-${index}`}
          className="flex items-center justify-between bg-black/20 border border-neutral-800/0 px-4 py-2"
        >
          <div className="flex-1 py-0">
            <span className="text-white text-sm hover:text-lumi-accent transition-colors duration-100">
              {member.name}
            </span>
            <span className="text-neutral-500 text-sm ml-4">{member.job}</span>
          </div>
          <button
            type="button"
            onClick={() => onRemove(index)}
            className="text-neutral-500 hover:text-red-400 transition-colors ml-4"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
}
